import { useMemo } from 'react';
import { GET_LOT_SIZINGS_KEY } from '@/keys';

export function useLotSizings() {
  const queryKey = useMemo(() => [...GET_LOT_SIZINGS_KEY] as const, []);

  return {
    queryKey,
  };
}
